import { useSelector } from "react-redux";
import { useBullseyeLocationDetails as useLocationDetails } from '@pcf-engineering/pcs-ui-kit/hooks';
import { BullseyeOptions } from "@pcf-engineering/pcs-ui-kit/hooks/store-locator/types";

import { storeCategoriesSelector } from "../../redux/selectors/sharedSelectors";
import { cartStoreSelector } from "../../redux/selectors/cartSelectors";

const useBullseyeLocationDetails = (options: BullseyeOptions, disable?: boolean) => {
  const stateCategories = useSelector(storeCategoriesSelector);
  const { selectedStore: stateActiveStore } = useSelector(cartStoreSelector);
  const details = useLocationDetails(
    {
      options,
      disable,
      stateActiveStore,
      stateCategories,
    },
  );

  return details;
};

export default useBullseyeLocationDetails;
